import { render } from "./ServiceAndNotes.vue?vue&type=template&id=2239b745&scoped=true"
import script from "./ServiceAndNotes.vue?vue&type=script&lang=js"
export * from "./ServiceAndNotes.vue?vue&type=script&lang=js"

import "./ServiceAndNotes.vue?vue&type=style&index=0&id=2239b745&scoped=true&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2239b745"]])

export default __exports__